// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__KZiIv","products":"Search_products__GYHzi","header":"Search_header__6OBD2","goBack":"Search_goBack__GFWYB","title":"Search_title__qsU-L"};